module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _vm._v("IN-ITSELF and FOR-ITSELF"), _c('a', {
    attrs: {
      "id": "fn2-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The for-itself (a thing which has to be what it is because it projects itself toward goals, and which therefore is what it still is not and still is not what it is) and the in-itself (a thing that is in itself) “are reunited by a synthetic connection which is nothing other than the for-itself. The for-itself, in fact, is nothing but the pure nihilation of the in-itself; it is like a hole of being at the heart of Being.”"), _c('a', {
    attrs: {
      "id": "ch02fn1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" In other words, it is a nihilation of being at the heart of an individual and particular in-itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This nihilation, which determines the reality of the for-itself, is enough to “cause a total upheaval to "), _c('i', [_vm._v("happen")]), _vm._v(" to the in-itself. This upheaval is the world.”"), _c('a', {
    attrs: {
      "id": "ch02fn2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" It follows that the for-itself is not independent. It is a nonsubstantial absolute (an absolute because it uses its freedom to create itself). It depends on the in-itself. It is for that reason always uncertain; its being is never established but always sought after. “The for-itself is always in suspense because its being is a perpetual reprieve. If it could ever join with its being, then the otherness would by the same stroke disappear and along with it possibles (that is, ends), knowledge, the world.”"), _c('a', {
    attrs: {
      "id": "ch02fn3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Ontologically and essentially, the in-itself takes precedence over the for-itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is only by making itself for-itself that being can aspire to be the cause of itself.”"), _c('a', {
    attrs: {
      "id": "ch02fn4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" This necessitates a break “with the identity-of-being of the in-itself, a withdrawal by being in relation to itself and the appearance of presence to self or consciousness.”"), _c('a', {
    attrs: {
      "id": "ch02fn5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" But consciousness is nihilation of being and “appears therefore as one stage in a progression toward the immanence of causality—"), _c('i', [_vm._v("i.e")]), _vm._v("., toward being a self-cause. The progression, however, stops there as a result of the insufficiency of being in the for-itself”"), _c('a', {
    attrs: {
      "id": "ch02fn6"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" (only things have plenitude of being). The for-itself is always an abortive struggle to find a cause, to avoid existing any longer without justification and to acquire the value of an in-and-for-itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The in-itself can of course “acquire” something only when it "), _c('i', [_vm._v("is")]), _vm._v(" presence or consciousness to itself. Here ontology can only declare “that "), _c('i', [_vm._v("everything takes place as if")]), _vm._v(" the in-itself in a project to found itself gave itself the modification of the for-itself. It is up to metaphysics to form the hypotheses which will allow us to conceive of this process as the absolute event (the upsurge of the for-itself) which comes to crown the individual venture which is the existence of being.”"), _c('a', {
    attrs: {
      "id": "ch02fn7"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Metaphysics must also determine whether the first attempt of the in-itself to found itself is to be interpreted as a “malady of being” and whether the for-itself is to be understood “as more profound malady pushed to nihilation.”"), _c('a', {
    attrs: {
      "id": "ch02fn8"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The in-itself and for-itself are two modalities, two modes of being. “The for-itself without the in-itself is a kind of abstraction; it could not exist any more than a color could exist without form or a sound without pitch and timbre.”"), _c('a', {
    attrs: {
      "id": "ch02fn9"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" “Doubtless the for-itself is a nihilation, but as nihilation it is; and is is in "), _c('i', [_vm._v("a priori")]), _vm._v(" unity with the in-itself.”"), _c('a', {
    attrs: {
      "id": "ch02fn10"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hence being as a unity consisting of in-itself and for-itself is an ideal Being, namely an In-self grounded on and identical to a For-itself; it is therefore the "), _c('i', [_vm._v("ens causa sui")]), _vm._v(", that is, the Being which is its own cause, the absolute and independent Being which the Scholastics called God. Considered from the point of view of this ideal, unrealizable Being, “the real is an abortive effort to attain to the dignity of the self-cause. Everything happens as if the world, man, and man-in-the-world succeeded in realizing only a missing God. Everything happens therefore as if the in-itself and the for-itself were presented in a state of disintegration in relation to an ideal synthesis,"), _c('a', {
    attrs: {
      "id": "ch02fn11"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch02fn11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" a synthesis which has never occured but which “is always indicated and always possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "image-left"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn2-1"
    }
  }, [_vm._v("*")]), _vm._v(" Sartre evidently translated Hegel’s "), _c('i', [_vm._v("Ansich")]), _vm._v(" and "), _c('i', [_vm._v("Fürsich")]), _vm._v(" as "), _c('i', [_vm._v("en-soi")]), _vm._v(" and "), _c('i', [_vm._v("pour-soi")]), _vm._v(". Tr.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a6be4e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter02.vue
// module id = 75
// module chunks = 0